var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMartiniGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.068 13.219C512.099 10.844 512.568 7.5 511.287 4.656C509.974 1.812 507.131 0 504.006 0H7.994C4.869 0 2.026 1.812 0.713 4.656C-0.568 7.5 -0.099 10.844 1.932 13.219L248 298.969V496H135.997C131.575 496 127.997 499.594 127.997 504S131.575 512 135.997 512H376.003C380.425 512 384.003 508.406 384.003 504S380.425 496 376.003 496H264V298.969L510.068 13.219ZM486.568 16L390.12 128H121.88L25.432 16H486.568ZM256 283.75L135.657 144H376.343L256 283.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMartiniGlass);
export default __webpack_public_path__ + "static/media/martini-glass.9b8fc911064e3b41c4cb175529640a12.svg";
export { ForwardRef as ReactComponent };